/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { EmployeeClockingProfile } from './EmployeeClockingProfile';
import {
    EmployeeClockingProfileFromJSON,
    EmployeeClockingProfileFromJSONTyped,
    EmployeeClockingProfileToJSON,
    EmployeeClockingProfileToJSONTyped,
} from './EmployeeClockingProfile';

/**
 * 
 * @export
 * @interface ListEmployeeClockingProfilesResponse
 */
export interface ListEmployeeClockingProfilesResponse {
    /**
     * 
     * @type {Array<EmployeeClockingProfile>}
     * @memberof ListEmployeeClockingProfilesResponse
     */
    data: Array<EmployeeClockingProfile>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListEmployeeClockingProfilesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListEmployeeClockingProfilesResponse interface.
 */
export function instanceOfListEmployeeClockingProfilesResponse(value: object): value is ListEmployeeClockingProfilesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListEmployeeClockingProfilesResponseFromJSON(json: any): ListEmployeeClockingProfilesResponse {
    return ListEmployeeClockingProfilesResponseFromJSONTyped(json, false);
}

export function ListEmployeeClockingProfilesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListEmployeeClockingProfilesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(EmployeeClockingProfileFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListEmployeeClockingProfilesResponseToJSON(json: any): ListEmployeeClockingProfilesResponse {
      return ListEmployeeClockingProfilesResponseToJSONTyped(json, false);
  }

  export function ListEmployeeClockingProfilesResponseToJSONTyped(value?: ListEmployeeClockingProfilesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(EmployeeClockingProfileToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

